/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-network': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.25 8.75c.69 0 1.25-.56 1.25-1.25V3.75c0-.69-.56-1.25-1.25-1.25H12.5c-.69 0-1.25.56-1.25 1.25V7.5c0 .69.56 1.25 1.25 1.25h1.25v2.563a3.125 3.125 0 00-2.438 2.437H8.75V12.5c0-.69-.56-1.25-1.25-1.25H6.25V8.687a3.125 3.125 0 10-1.25 0v2.563H3.75c-.69 0-1.25.56-1.25 1.25v3.75c0 .69.56 1.25 1.25 1.25H7.5c.69 0 1.25-.56 1.25-1.25V15h2.563A3.125 3.125 0 1015 11.312V8.75h1.25zM3.75 5.625a1.875 1.875 0 113.75 0 1.875 1.875 0 01-3.75 0zM7.5 16.25H3.75V12.5H7.5v3.75zm8.75-1.875a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zM12.5 3.75h3.75V7.5H12.5V3.75z"/>'
  }
})
